export default {
  coupon_rule_new: {}
}
